import script from "./id-pswd-wrtg.vue?vue&type=script&setup=true&lang=js"
export * from "./id-pswd-wrtg.vue?vue&type=script&setup=true&lang=js"

import "./id-pswd-wrtg.vue?vue&type=style&index=0&id=7f09d478&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f09d478"]])

export default __exports__